import { Row, Col } from 'react-bootstrap'

import CarouselElement from "../elements/CarouselElement"
import UltimasNoticias from './UltimasNoticias'

import imageNoticias1001 from '../assets/images/noticias/noticias_1_001.jpeg'
import imageNoticias1002 from '../assets/images/noticias/noticias_1_002.jpeg'
import imageNoticias1003 from '../assets/images/noticias/noticias_1_003.jpeg'

import imageNoticias2001 from '../assets/images/noticias/noticias_2_001.JPG'
import imageNoticias2002 from '../assets/images/noticias/noticias_2_002.JPG'
import imageNoticias2003 from '../assets/images/noticias/noticias_2_003.JPG'
import imageNoticias2004 from '../assets/images/noticias/noticias_2_004.JPG'
import imageNoticias2005 from '../assets/images/noticias/noticias_2_005.JPG'
import imageNoticias2006 from '../assets/images/noticias/noticias_2_006.jpeg'

import imageBeneficios from '../assets/images/banner_sindicato.png'

import ImageElement from '../elements/ImageElement'

function Inicio() {
  const data = {
    images: [
      {
        content: imageNoticias1001,
        title: ''
      },
      {
        content: imageNoticias1002,
        title: ''
      },
      {
        content: imageNoticias1003,
        title: ''
      },
    ]
  }
  const image = { teste: 1 }
  return (
    <Row>
      <Col xs={12} sm={12} md={12} lg={12}>
        <CarouselElement data={data} />
      </Col>
      <Col xs={12} sm={12} md={12} lg={12}>
        <UltimasNoticias />
      </Col>
      <Col xs={12} sm={12} md={12} lg={12} style={{ display: 'none' }}>
        <Row>
          <Col>
            <ImageElement content='https://placehold.co/400' />
          </Col>
          <Col>
            <ImageElement content='https://placehold.co/400' />
          </Col>
          <Col>
            <ImageElement content={imageBeneficios} />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Inicio